module.exports = __webpack_public_path__ + "static/09-thumb-cd8134288ccfa91e3263dbf6c001dbbc.jpg";